var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _c("div", { staticClass: "img" }, [
      _c("img", {
        attrs: { src: _vm.contentUrl + _vm.meditationOfDay.image, alt: "" }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card__content" }, [
      _c("h3", [_vm._v(_vm._s(_vm.meditationOfDay.title))]),
      _vm._v(" "),
      _c("p", [_vm._v(_vm._s(_vm.meditationOfDay.readTime))]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "card__action",
          on: {
            click: function($event) {
              return _vm.$router.push(
                "/profile/meditations#meditation" + _vm.meditationId
              )
            }
          }
        },
        [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("profile.home.startMeditation")) +
              "\n    "
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }